var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProductGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 973",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.261 39.143a1.507 1.507 0 0 1-1.294-.75l-2.009-3.416-2.006 3.416a1.512 1.512 0 0 1-1.3.753 1.4 1.4 0 0 1-.416-.061l-4.277-1.256v5.7a1.018 1.018 0 0 0 .756.994l6.756 1.734a1.982 1.982 0 0 0 .969 0l6.76-1.729a1.023 1.023 0 0 0 .756-.994v-5.7l-4.281 1.253a1.4 1.4 0 0 1-.414.056zm6.643-3.6-1.604-3.29a.508.508 0 0 0-.522-.285l-7.82 1.022 2.865 4.875a.508.508 0 0 0 .578.234l6.184-1.811a.532.532 0 0 0 .319-.74zm-18.283-3.29L.012 35.547a.526.526 0 0 0 .316.737L6.512 38.1a.508.508 0 0 0 .578-.234l2.868-4.876-7.818-1.023a.508.508 0 0 0-.519.285z",
    transform: "translate(6.042 -23.142)",
    style: {
      fill: "#748d6f"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductGreen);
export default __webpack_public_path__ + "static/media/icon-product-green.9b5b0257.svg";
export { ForwardRef as ReactComponent };